import React from "react";
import UpdateEmailDialog from "./UpdateLoginDetails/UpdateEmailDialogue";
import UpdatePasswordDialog from "./UpdateLoginDetails/UpdatePasswordDialogue";

function UpdateLoginDetail() {
  return (
    <div className="section-process-content upload-doc-con h-full w-full flex flex-col justify-center items-center">
      <div className="w-5/6 con-main-table-inner flex gap-3 flex-wrap justify-center items-center">

        <UpdatePasswordDialog />
        <UpdateEmailDialog />

      </div>
    </div>
  );
}

export default UpdateLoginDetail;
